import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Select, NumberInput, Checkbox } from "@mantine/core";
import { ReactComponent as SelectIcon } from "../../assets/fi-rr-angle-small-down.svg";
import { ReactComponent as UploadIcon } from "../../assets/humbleicons_upload.svg";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./additionalClaim.css"
import axios from "axios";
import Swal from "sweetalert2";
import attachmenturl from "../../api/attachmenturl";
import base_url from "../../api/bootapi";
const AdditionalClaim = ({ claim,setbackdropopen,setOpenAdditonalModal,setUpdatedPOA }) => {
  
let flight_details = claim?.flight_details ?? [];
  let actual_flight_details = claim?.actual_flight_details ?? [];
  let sub_claims = claim?.sub_claims ?? [];
  console.log(flight_details)

  
const merged = [...flight_details, ...actual_flight_details];

// const uniqueFlights = Object.values(
//   merged.reduce((acc, item) => {
//     const key = `${item.flight_number}-${item.airline}`;
//     if (!acc[key]) {
//       acc[key] = item; // keep first one
//     }
//     return acc;
//   }, {})
// );

console.log(merged);

  const mainTraveler = {
        first_name: claim?.first_name,
        last_name: claim?.last_name,
        date_of_birth: claim?.date_of_birth,
        passport_number: claim?.passport_number,
        tickets: claim?.tickets,
        country: claim?.nationality,
               airline_res_no: claim?.airline_res_no,
        boarding_pass :claim?.boarding_pass,
        passport :claim?.passport
      }

  sub_claims = [mainTraveler,...sub_claims]

  const {
    handleSubmit,
    control,
    setError,
    clearErrors,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sub_claims: [],
      flight_details: [],
      actual_flight_details: [],
      claim_type: "",
      amount: "",
    //   currency_type: "",
      claim_explanation: "",
      other_claim_doc: null,
      additional_docs: null,
    },
  });



  const claimType = watch("claim_type");

useEffect(() => {
  // whenever claim type changes → reset selected flights
  
    // reset flight details to empty
    setValue("flight_details", []);
  
}, [claimType, setValue]);

  const selectedTravellers = watch("sub_claims");
  const selectedFlights = watch("flight_details");
  const selectedActualFlights = watch("actual_flight_details");
  // console.log(errors)
  
const onSubmit = async(data) => {
  if (selectedTravellers.length === 0) {
    setError("sub_claims", {
      type: "manual",
      message: "Select at least one Traveller",
    });
    return;
  } else clearErrors("sub_claims");

  if (selectedFlights.length === 0 && data.claim_type === "others") {
    setError("flight_details", {
      type: "manual",
      message: "Select at least one Flight",
    });
    return;
  } else clearErrors("flight_details");

   if (selectedActualFlights.length === 0) {
    setError("actual_flight_details", {
      type: "manual",
      message: "Select at least one Flight",
    });
    return;
  } else clearErrors("actual_flight_details");

    
   
  try {
      const travellers = data.sub_claims?.map((member) => {
           return {
        first_name: member?.first_name?.trim(),
        last_name: member.last_name,
        date_of_birth: member.date_of_birth,
        passport_number: member.passport_number,
        tickets: member.tickets,
        country: member.country,
               airline_res_no: member.airline_res_no,
        boarding_pass :member.boarding_pass
      };
    });      // full traveller objects

      const formData = new FormData();
      
      // const cleanedFlights = flight_details.map(({ id, claim_id, ...rest }) => rest);
      // const cleanedActualFlights = flight_details.map(({ id, claim_id, ...rest }) => rest);
  
    
    let mainTraveler = data?.sub_claims?.[0]

   let formatedSubClaims = await Promise.all(
  data.sub_claims?.slice(1)?.map(async(member, index) => {

    let memberData = {
      first_name: member?.first_name?.trim(),
      last_name: member.last_name,
      date_of_birth: member.date_of_birth,
      passport_number: member.passport_number,
      tickets: member.tickets,
      country: member.country,
      airline_res_no: member.airline_res_no,
    };

    if (member.passport) {
      const fileResponse = await fetch(attachmenturl + member.passport);
      const blob = await fileResponse.blob();

      const fileName =
        (attachmenturl + member.passport).split("/").pop() || "passport.webp";

      const file = new File([blob], fileName, { type: blob.type });
      formData.append(`passport_${index + 1}`, file);

      memberData.passport = `passport_${index + 1}`;
    }

    if (member.boarding_pass) {
      const fileResponse = await fetch(attachmenturl + member.boarding_pass);
      const blob = await fileResponse.blob();

      const fileName =
        (attachmenturl + member.boarding_pass).split("/").pop() ||
        "boarding_pass.webp";

      const file = new File([blob], fileName, { type: blob.type });
      formData.append(`boarding_pass_${index + 1}`, file);

      memberData.boarding_pass = `boarding_pass_${index + 1}`;
    }

    return memberData;
  })
);





    let formObject = {
      
      first_name: mainTraveler?.first_name,
      last_name: mainTraveler?.last_name,
      address: claim?.address,
      passport_number: mainTraveler?.passport_number,
      nationality: claim?.nationality,
      date_of_birth: claim?.date_of_birth,
      airline_res_no: mainTraveler?.airline_res_no,
      flight_details: data?.claim_type === "others" ? data?.flight_details?.map(({ id, claim_id, ...rest }) => rest) : [],
      actual_flight_details:data?.actual_flight_details?.map(({ id, claim_id, ...rest }) => rest),
      source_of_claim: "flyandclaim",
      contact_no: claim?.contact_no,
      email_id: claim?.email_id,
      delay:  data?.claim_type === "others" ? claim.delay :null,
      note: claim?.note,
      sub_claims: formatedSubClaims,
      envelope_id: claim?.envelope_id,
      type_of_claim: data.claim_type,
      tickets: mainTraveler?.tickets,
      num_of_passenger: claim?.num_of_passenger,
      postal_code: claim?.postal_code,
      state: claim?.state,
      city: claim?.city,
      // user_id: user?.id,
      // other_claims: additionalClaimDataPayload,
      // signers: signers,
      status: "incomplete",  
      claim_amount:data?.amount,
          currency_type: 'USD',
        main_claim_id: claim.id,
          

      
    };

   
 const jsonFormObject = JSON.stringify(formObject);
      // Append required file
      
      formData.append('data',jsonFormObject)
    if (data.other_claim_doc && data.other_claim_doc[0]) {
      formData.append("document", data.other_claim_doc[0]);
    }

 
    if (data.additional_docs && data.additional_docs.length > 0) {
      
      for (let i = 0; i < data.additional_docs.length; i++) {
        formData.append("document", data.additional_docs[i]);
      }
      
    }


    // Fetch file from URL
    if (mainTraveler?.passport) {
       const fileresponse = await fetch(attachmenturl + mainTraveler?.passport);
  const blob = await fileresponse.blob();

  // Extract name from URL
  const fileName = (attachmenturl + mainTraveler?.passport).split("/").pop() || "passport.webp";

  // Append to formdata as a File
  const file = new File([blob], fileName, { type: blob.type });

  formData.append("passport", file);
    }

  //    if (claim?.power_of_attorney && data.sub_claims.length > 1) {
  //      const fileresponse = await fetch(attachmenturl + claim?.power_of_attorney);
  // const blob = await fileresponse.blob();

  // // Extract name from URL
  // const fileName = (attachmenturl + claim?.power_of_attorney).split("/").pop() || "power_of_attorney.webp";

  // // Append to formdata as a File
  // const file = new File([blob], fileName, { type: blob.type });

  // formData.append("power_of_attorney", file);
  //   }

    if (mainTraveler?.boarding_pass) {
       const fileresponse = await fetch(attachmenturl + mainTraveler?.boarding_pass);
  const blob = await fileresponse.blob();

  // Extract name from URL
  const fileName = (attachmenturl + mainTraveler?.boarding_pass).split("/").pop() || "boarding_pass.webp";

  // Append to formdata as a File
  const file = new File([blob], fileName, { type: blob.type });

  formData.append("boarding_pass", file);
    }
 

setOpenAdditonalModal(false)
    setbackdropopen(true);
    const response = await axios.post(
      `${base_url.api1}/tourapp/compensation_request`,
        formData,
       
     
    );


    setbackdropopen(false);
    Swal.fire({
  icon: "success",
  title: "Success",
  text: "Additional claim added",
}).then((result) => {
  if (result.isConfirmed) {
    console.log("Callll ====> Calll")
    setUpdatedPOA(prev=>!prev)
  }
});

    console.log("UPLOAD SUCCESS:", response.data);

  } catch (error) {
    setbackdropopen(false)
    console.error("UPLOAD ERROR:", error);
  }


  console.log("FINAL CLAIM:", data);
};

  return (
    <>
      
        <form onSubmit={handleSubmit(onSubmit)} className="additional-claim-form" >

     
          <div>
               <div>
                   
                  <div  className="additional-claim-form-grid">
                      
                 
     
        <div>
          <label className="input-label">Select Claim Type <span style={{color:"red"}}>*</span></label>

          <Controller
            name="claim_type"
            control={control}
            rules={{ required: "Please select claim type" }}
            render={({ field }) => (
              <Select
                placeholder="Select Claim"
                data={[
                  { value: "lost_baggage", label: "Lost Baggage" },
                  { value: "damage_baggage", label: "Damage Baggage" },
                  { value: "travel_expenses", label: "Travel Expenses" },
                  { value: "delayed_baggage", label: "Delayed Baggage" },
                  { value: "others", label: "Others" },
                ]}
                rightSection={<SelectIcon />}
                value={field.value}
                onChange={(v) => field.onChange(v)}
              />
            )}
          />

          {errors.claim_type && (
            <p className="error-text">{errors.claim_type.message}</p>
          )}
        </div>

                       <div style={{ width: "100%" }}>
          <label className="input-label">Amount <span style={{color:"red"}}>*</span></label>

          <Controller
            name="amount"
            control={control}
            rules={{
              required: "Enter amount",
            }}
            render={({ field }) => (
              <NumberInput
                hideControls
                placeholder="Enter Amount"
                value={field.value}
                onChange={(v) => field.onChange(v)}
              />
            )}
          />

          {errors.amount && (
            <p className="error-text">{errors.amount.message}</p>
          )}
        </div>
      
        <div className="custom-input" style={{ width: "100%",gap:0 }}>
          <label className="input-label">Claim Document <span style={{color:"red"}}>*</span></label>

          <Controller
            name="other_claim_doc"
            control={control}
            rules={{ required: "Please attach a document" }}
            render={({ field }) => (
              <div>
                <input
                        type="file"
                        id="additional-doc-file"
                  accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                        onChange={(e) => field.onChange(e.target.files)}
                        style={{display:"none"}}
                    />
                    
                     
                                      
                                        <div
                                          onClick={() =>
                                            document.getElementById(`additional-doc-file`).click()
                                          }
                        className="input-box"
                        
                                          style={{
                                            color: field.other_claim_doc
                                              ? "#222222"
                                                  : "#7b8287",
                                              marginTop:0
                                          }}
                                        >
                                         {field?.value?.[0]?.name ?? "Upload File"}
                                          <UploadIcon />
                                        </div>
                                       
                                      </div>
              
            )}
          />

          {errors.other_claim_doc && (
            <p className="error-text">{errors.other_claim_doc.message}</p>
          )}
        </div>
     

     
    
        {/* <div style={{ width: "100%" }}>
          <label className="input-label">Currency *</label>

          <Controller
            name="currency_type"
            control={control}
            rules={{ required: "Select currency" }}
            render={({ field }) => (
              <Select
                placeholder="Select Currency"
                rightSection={<SelectIcon />}
                data={[
                  { value: "usd", label: "USD" },
                  { value: "eur", label: "EURO" },
                ]}
                value={field.value}
                onChange={(v) => field.onChange(v)}
              />
            )}
          />

          {errors.currency_type && (
            <p className="error-text">{errors.currency_type.message}</p>
          )}
        </div> */}
                      
                       <div className="custom-input" style={{ width: "100%",gap:0 }}>
          <label className="input-label">Additional Documents </label>

          <Controller
            name="additional_docs"
            control={control}
           
            render={({ field }) => (
              <div>
                <input
                        type="file"
                        id="additional-doc-file-other"
                  accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                        onChange={(e) => field.onChange(e.target.files)}
                        style={{ display: "none" }}
                        multiple
                    />
                    
                     
                                      
                                        <div
                                          onClick={() =>
                                            document.getElementById(`additional-doc-file-other`).click()
                                          }
                        className="input-box"
                        
                                          style={{
                                            color: field.additional_docs
                                              ? "#222222"
                                                  : "#7b8287",
                                              marginTop:0
                                          }}
                                        >
                                         {field?.value?.[0]?.name ?? "Upload File"}
                                          <UploadIcon />
                                        </div>
                                       
                                      </div>
              
            )}
          />

          {/* {errors.additional_docs && (
            <p className="error-text">{errors.additional_docs.message}</p>
          )} */}
        </div>

       
                    
                      
                       </div>

      {/* ======================================================
          EXPLANATION
       ====================================================== */}
      <div style={{ marginTop: "30px" }}>
        <label className="input-label">Additional Details *</label>

        <Controller
          name="claim_explanation"
          control={control}
          rules={{ required: "Enter additional details" }}
          render={({ field }) => (
            <textarea
              rows={6}
              placeholder="Add any relevant details about your claim"
              className="input-box"
              {...field}
            />
          )}
        />

        {errors.claim_explanation && (
          <p className="error-text">{errors.claim_explanation.message}</p>
        )}
                  </div>
                  
                  
              </div>
              <div style={{ flex: 1}}>
                    <h4 style={{ marginBottom: "20px", fontSize: "22px",marginTop:"30px" }}>
        Select Travelers
      </h4>

      <Controller
        name="sub_claims"
        control={control}
        render={({ field }) => (
          <>
                {sub_claims.map((traveler) => {

  const isSelected = field.value.some(
          (t) => t.id === traveler.id
        );
                    return(
                        <div
                            key={traveler.id}
                            className={`new-additonal-box ${isSelected ? "new-addtional-box-select":''}`}
                        >
                            <Checkbox
              checked={isSelected}
            //   label="Select"
              onChange={(e) => {
                if (e.target.checked) {
                  // ADD whole object
                  field.onChange([...field.value, traveler]);
                } else {
                  // REMOVE whole object
                  field.onChange(
                    field.value.filter((t) => t.id !== traveler.id)
                  );
                }
              }}
            />

                            <div className="new-additonal-box-form">
                                <span>Name</span>
                                <span>
                                    {traveler.first_name} {traveler.last_name}
                                </span>
                            </div>

                            <div className="new-additonal-box-form">
                                <span>Date of birth</span>
                                <span>
                                    {moment(traveler.date_of_birth).format("MM/DD/YYYY")}
                                </span>
                            </div>

                            <div className="new-additonal-box-form">
                                <span>Country</span>
                                <span>{traveler.country}</span>
                            </div>

                            <div className="new-additonal-box-form">
                                <span>Passport number</span>
                                <span>{traveler.passport_number}</span>
                            </div>

                            <div className="new-additonal-box-form">
                                <span>Airline reservation number</span>
                                <span>{traveler.airline_res_no}</span>
                            </div>

                            <div className="new-additonal-box-form">
                                <span>Ticket number</span>
                                <span>{traveler.tickets}</span>
                            </div>
                        </div>
                    )
        
                }        )}
          </>
        )}
      />

      {/* traveller OR flight error */}
     {errors.sub_claims && <p className="error-text">{errors.sub_claims.message}</p>}

     

      {/* ======================================================
          FLIGHTS
       ====================================================== */}
      <h4 style={{ marginBottom: "20px", fontSize: "22px",marginTop:"30px" }}>
        Select Flights
            </h4>
            
    {(claimType === "others" || claimType === "") &&       <div>
    {flight_details?.length > 0  &&  <h5 style={{ marginBottom: "20px", fontSize: "18px",marginTop:"30px" }}>
        Originally Flight Details
      </h5>}
      <Controller
        name="flight_details"
        control={control}
        render={({ field }) => (
          <>
            
          
                {flight_details.map((flight) =>{
                
                     const isSelected = field.value.some(
          (f) => f.id === flight.id
        );
                    return (
                    <div
                        key={flight.id}
                        className={`new-additonal-box ${isSelected ? "new-addtional-box-select":''}`}
                    >
                       <Checkbox
              checked={isSelected}
            //   label="Select"
              onChange={(e) => {
                if (e.target.checked) {
                  // ADD full flight object
                  field.onChange([...field.value, flight]);
                } else {
                  // REMOVE full flight object
                  field.onChange(
                    field.value.filter(
                      (f) => f.id !== flight.id
                    )
                  );
                }
              }}
            />

                        <div className="new-additonal-box-form">
                            <span>Airline</span>
                            <span>{flight.airline}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Flight Number</span>
                            <span>{flight.flight_number}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Departure Airport</span>
                            <span>{flight.airport_of_origin}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Arrival Airport</span>
                            <span>{flight.airport_of_destination}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Departure Date</span>
                            <span>
                                {moment(flight.scheduled_departure).format(
                                    "MM-DD-YYYY hh:mm A"
                                )}
                            </span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Arrival Date</span>
                            <span>
                                {moment(flight.scheduled_arrival).format(
                                    "MM-DD-YYYY hh:mm A"
                                )}
                            </span>
                        </div>
                    </div>
                )
                })}
            

           
           
          </>
        )}
      />

     {errors.flight_details && <p className="error-text">{errors.flight_details.message}</p>}
            </div>
              
            
  } 
          
            <div>
                
                
              

           {actual_flight_details?.length > 0  &&  <h5 style={{ marginBottom: "20px", fontSize: "18px",marginTop:"30px" }}>
        Actual Flight Details
      </h5>}   
             <Controller
        name="actual_flight_details"
        control={control}
        render={({ field }) => (
          <>
            
         
             {actual_flight_details.map((flight) =>{
                
                     const isSelected = field.value.some(
          (f) => f.id === flight.id
        );
                    return (
                    <div
                        key={flight.id}
                        className={`new-additonal-box ${isSelected ? "new-addtional-box-select":''}`}
                    >
                       <Checkbox
              checked={isSelected}
            //   label="Select"
              onChange={(e) => {
                if (e.target.checked) {
                  // ADD full flight object
                  field.onChange([...field.value, flight]);
                } else {
                  // REMOVE full flight object
                  field.onChange(
                    field.value.filter(
                      (f) => f.id !== flight.id
                    )
                  );
                }
              }}
            />

                        <div className="new-additonal-box-form">
                            <span>Airline</span>
                            <span>{flight.actual_airline}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Flight Number</span>
                            <span>{flight.actual_flight_number}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Departure Airport</span>
                            <span>{flight.actual_airport_of_origin}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Arrival Airport</span>
                            <span>{flight.actual_airport_of_destination}</span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Departure Date</span>
                            <span>
                                {moment(flight.actual_departure).format(
                                    "MM-DD-YYYY hh:mm A"
                                )}
                            </span>
                        </div>

                        <div className="new-additonal-box-form">
                            <span>Arrival Date</span>
                            <span>
                                {moment(flight.actual_arrival).format(
                                    "MM-DD-YYYY hh:mm A"
                                )}
                            </span>
                        </div>
                    </div>
                )
                })}
          </>
        )}
      />

     {errors.actual_flight_details && <p className="error-text">{errors.actual_flight_details.message}</p>}

    </div>

              </div>

             
          </div>
    
    

      <div style={{display:"flex",justifyContent:"flex-end",marginTop:"20px"}}>
 <button type="submit" className="submit-btn">
        Submit Claim
      </button>
      </div>
     

     
    </form>
    </>

  
  );
};

export default AdditionalClaim;
